import { useState, useEffect, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MyContext } from '../../Context/MyProvider';
import Account from './Account';
import { useSnackbar } from 'notistack';
import secureLocalStorage from 'react-secure-storage';
import DLogo from "../../images/default_pi2c.png";
const Header = () => {

  const { BaseUrl, isLoginAuth, showModel, setIsLoginAuth, profileShow, setProfileShow, webLogo, catActivePackage, aiActivePackage } = useContext(MyContext);

  const { enqueueSnackbar } = useSnackbar();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const location = useLocation();

  const getHashCode = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return Math.abs(hash);
  };

  const gradients = [
    "from-indigo-500 to-purple-600",
    "from-pink-500 to-rose-600",
    "from-emerald-400 to-teal-600",
    "from-amber-400 to-orange-600",
    "from-cyan-500 to-blue-600",
    "from-fuchsia-500 to-pink-600",
    "from-violet-500 to-purple-700"
  ];

  const renderAvatar = (sizeClass = "w-full h-full text-[16px]") => {
    const initial = (name || email || "?").trim().charAt(0).toUpperCase();
    const hashSeed = name || email || 'default';
    const hashCode = getHashCode(hashSeed);
    const gradient = gradients[hashCode % gradients.length];
    return (
      <div className={`${sizeClass} rounded-full bg-gradient-to-tr ${gradient} flex items-center justify-center text-white font-black shadow-inner uppercase select-none`}>
        {initial}
      </div>
    );
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const LocalData = secureLocalStorage.getItem("Localdata");
    if (LocalData) {
      const { name, email } = JSON.parse(LocalData);
      setName(name || "");
      setEmail(email);
    }
  }, [isLoginAuth, secureLocalStorage.getItem("Localdata")]);

  useEffect(() => {
    document.body.style.overflow = (showModel || profileShow || mobileMenuOpen) ? "hidden" : "auto";
  }, [showModel, profileShow, mobileMenuOpen]);

  const scrollToSection = (id) => {
    if (location.pathname !== "/") {
      window.location.href = `/#${id}`;
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleSingOut = () => {
    enqueueSnackbar('Logout successfully !!', { variant: 'success' });
    secureLocalStorage.clear();
    setIsLoginAuth(true);
    setIsOpen(false);
    setMobileMenuOpen(false);
    window.location.href = "/";
  }

  return (

    <div>

      <div className={`${scrolled ? "header-sticky" : "header"}`}>
        <div className="width_container px-4 sm:px-6 lg:px-8">
          <div className={`flex justify-between items-center transition-all duration-300 ${scrolled ? "py-3" : "py-5"}`}>

            <div className="w-[25%] max-_426_:w-[50%]">
              <Link to="/" className="text-2xl max-_426_:text-[20px] font-bold tracking-tight flex items-center gap-2 transition-colors duration-300 logo-text whitespace-nowrap">
                <img src={BaseUrl + webLogo} className='w-[30px]' alt="web logo" />
                AstroSphere API
              </Link>
            </div>


            <div className="w-[50%] max-sm:hidden">
              <ul className="flex gap-[5px] items-center justify-center font-medium">
                <button onClick={() => scrollToSection("module-price")} className="text-[15px] hover:bg-white hover:text-[#4f46e5] px-[20px] py-[8px] rounded-full duration-300 transition-all nav-btn whitespace-nowrap">Module Pricing</button>
                <button onClick={() => scrollToSection("ai-price")} className="text-[15px] hover:bg-white hover:text-[#4f46e5] px-[20px] py-[8px] rounded-full duration-300 transition-all nav-btn whitespace-nowrap">Ai Pricing</button>
                <button onClick={() => scrollToSection("review")} className="text-[15px] hover:bg-white hover:text-[#4f46e5] px-[20px] py-[8px] rounded-full duration-300 transition-all nav-btn whitespace-nowrap">Review</button>
                <button onClick={() => scrollToSection("faq's")} className="text-[15px] hover:bg-white hover:text-[#4f46e5] px-[20px] py-[8px] rounded-full duration-300 transition-all nav-btn whitespace-nowrap">Faq's</button>
                <Link to="/contact" className="text-[15px] hover:bg-white hover:text-[#4f46e5] px-[20px] py-[8px] rounded-full duration-300 transition-all nav-btn whitespace-nowrap">Contact</Link>
              </ul>
            </div>

            <div className="w-[25%] max-_426_:w-[50%] justify-end flex items-center gap-4 relative">
              {isLoginAuth
                ? <Link to="/auth/login" className="px-6 py-2 rounded-full font-semibold transition duration-300 shadow-md max-_426_:text-[15px] max-sm:hidden login-btn whitespace-nowrap">
                  Login
                </Link>
                : <div className="w-[45px] h-[45px] max-sm:hidden">
                  <button onClick={() => setIsOpen(!isOpen)} className="w-full h-full rounded-full flex items-center justify-center">
                    {renderAvatar("w-full h-full text-[18px]")}
                  </button>
                </div>}

              {/* Hamburger Button */}
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="hidden max-sm:flex flex-col justify-between w-[22px] h-[16px] z-50 focus:outline-none cursor-pointer"
                aria-label="Toggle Menu"
              >
                <motion.span
                  animate={mobileMenuOpen ? { rotate: 45, y: 7 } : { rotate: 0, y: 0 }}
                  transition={{ duration: 0.2 }}
                  className="w-full h-[2px] rounded transition-colors duration-300 hamburger-line"
                />
                <motion.span
                  animate={mobileMenuOpen ? { opacity: 0 } : { opacity: 1 }}
                  transition={{ duration: 0.2 }}
                  className="w-full h-[2px] rounded transition-colors duration-300 hamburger-line"
                />
                <motion.span
                  animate={mobileMenuOpen ? { rotate: -45, y: -7 } : { rotate: 0, y: 0 }}
                  transition={{ duration: 0.2 }}
                  className="w-full h-[2px] rounded transition-colors duration-300 hamburger-line"
                />
              </button>

              <AnimatePresence initial={false}>
                {isOpen && <motion.div
                  key="content"
                  initial="close"
                  animate="open"
                  exit="close"
                  variants={{
                    open: { opacity: 1, y: 0 },
                    close: { opacity: 0, y: 30 },
                  }}
                  transition={{ duration: 0.3 }}
                  className="absolute top-[75px] right-0 z-20"
                >
                  <div className="menu_box">

                    <div className="flex items-center gap-[10px]">
                      <div className="max-w-[45px] min-w-[45px] h-[45px] rounded-full flex items-center justify-center">
                        {renderAvatar("w-full h-full text-[18px]")}
                      </div>
                      <div className="overflow-hidden">
                        <p className="text-[16px] font-bold text-onColor-heading trime">{name}</p>
                        <p className="text-[14px] text-onColor-body -mt-0.5 trime">{email}</p>
                      </div>
                    </div>

                    {catActivePackage?.total_token && <div className="bg-black text-white mt-[15px] py-[12px] px-[15px] rounded-[10px]">
                      <span className='uppercase text-[11px] text-gray-400 tracking-wider font-semibold'>Current Module Plan</span>
                      <div className="flex justify-between items-center mt-1.5 mb-1">
                        <h1 className='font-bold text-[15px]'>
                          {parseInt(catActivePackage?.PackageID) === 0 ? "Welcome Bonus" : (catActivePackage?.title || "No Plan")}
                        </h1>
                        <span onClick={() => { setIsOpen(false); setProfileShow(2); }} className='font-semibold text-[13px] text-[#4f46e5] cursor-pointer hover:text-[#6366f1] transition-colors duration-200'>Upgrade</span>
                      </div>
                      {catActivePackage && <p className='text-[13px] text-gray-300'>Token balance : {(parseInt(catActivePackage?.used_token) || 0).toLocaleString()}</p>}
                    </div>}

                    {aiActivePackage?.total_token && <div className="bg-black text-white mt-[15px] py-[12px] px-[15px] rounded-[10px]">
                      <span className='uppercase text-[11px] text-gray-400 tracking-wider font-semibold'>Current Ai Plan</span>
                      <div className="flex justify-between items-center mt-1.5 mb-1">
                        <h1 className='font-bold text-[15px]'>
                          {parseInt(aiActivePackage?.AiPlanID) === 0 ? "Welcome AI Bonus" : (aiActivePackage?.title || "No Plan")}
                        </h1>
                        <span onClick={() => { setIsOpen(false); setProfileShow(3); }} className='font-semibold text-[13px] text-[#4f46e5] cursor-pointer hover:text-[#6366f1] transition-colors duration-200'>Upgrade</span>
                      </div>
                      {aiActivePackage && <p className='text-[13px] text-gray-300'>Token balance : {(parseInt(aiActivePackage?.used_token) || 0).toLocaleString()}</p>}
                    </div>}

                    <button onClick={() => { setIsOpen(false); setProfileShow(1); }} className="w-full mt-[10px] py-[10px] p-[15px] rounded-[10px] flex items-center gap-[8px] hover:bg-black hover:text-white duration-300">
                      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path><circle cx="12" cy="12" r="3"></circle></svg>
                      <p className='text-[15px]'>Account setting</p>
                    </button>

                    <div className="border-b pt-[10px]"></div>

                    <button onClick={handleSingOut} className="w-full mt-[10px] py-[10px] p-[15px] rounded-[10px] flex items-center gap-[8px] hover:bg-black hover:text-white duration-300">
                      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m16 17 5-5-5-5"></path><path d="M21 12H9"></path><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path></svg>
                      <p className='text-[15px]'>Sign out</p>
                    </button>

                  </div>
                </motion.div>}
              </AnimatePresence>

            </div>
          </div>
        </div>
      </div>

      {/* Mobile Drawer Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <>
            {/* Backdrop with blur */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setMobileMenuOpen(false)}
              className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[99]"
            />

            {/* Drawer */}
            <motion.div
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "spring", damping: 25, stiffness: 200 }}
              className="fixed right-0 top-0 bottom-0 w-[280px] bg-white shadow-2xl z-[100] p-6 flex flex-col justify-between"
            >
              <div>
                <div className="flex justify-between items-center pb-6 border-b border-gray-100">
                  <span className="text-[20px] font-bold text-black flex items-center gap-2">
                    <img src={BaseUrl + webLogo} className="w-[24px]" alt="web logo" />
                    AstroSphere
                  </span>
                  <button
                    onClick={() => setMobileMenuOpen(false)}
                    className="p-1.5 rounded-full hover:bg-gray-100 transition-colors"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                  </button>
                </div>

                <ul className="flex flex-col gap-4 mt-6">
                  <li>
                    <button
                      onClick={() => {
                        setMobileMenuOpen(false);
                        scrollToSection("module-price");
                      }}
                      className="w-full text-left text-gray-700 hover:text-[#4f46e5] py-2 font-semibold text-[16px] transition-colors"
                    >
                      Module Pricing
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => {
                        setMobileMenuOpen(false);
                        scrollToSection("ai-price");
                      }}
                      className="w-full text-left text-gray-700 hover:text-[#4f46e5] py-2 font-semibold text-[16px] transition-colors"
                    >
                      Ai Pricing
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => {
                        setMobileMenuOpen(false);
                        scrollToSection("review");
                      }}
                      className="w-full text-left text-gray-700 hover:text-[#4f46e5] py-2 font-semibold text-[16px] transition-colors"
                    >
                      Review
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => {
                        setMobileMenuOpen(false);
                        scrollToSection("faq's");
                      }}
                      className="w-full text-left text-gray-700 hover:text-[#4f46e5] py-2 font-semibold text-[16px] transition-colors"
                    >
                      Faq's
                    </button>
                  </li>
                  <li>
                    <Link
                      to="/contact"
                      onClick={() => setMobileMenuOpen(false)}
                      className="w-full text-left text-gray-700 hover:text-[#4f46e5] py-2 font-semibold text-[16px] transition-colors block"
                    >
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="pt-6 border-t border-gray-100 flex flex-col gap-3">
                {isLoginAuth ? (
                  <Link
                    to="/auth/login"
                    onClick={() => setMobileMenuOpen(false)}
                    className="bg-black text-white px-6 py-3 rounded-full font-semibold text-center transition duration-300 shadow-md text-[15px]"
                  >
                    Login
                  </Link>
                ) : (
                  <div className="flex flex-col gap-3">
                    <div className="flex items-center gap-3">
                      <div className="w-[40px] h-[40px] rounded-full overflow-hidden">
                        {renderAvatar("w-full h-full text-[16px]")}
                      </div>
                      <div className="flex-1 overflow-hidden">
                        <p className="text-[15px] font-bold text-black trime">{name}</p>
                        <p className="text-[13px] text-gray-500 trime">{email}</p>
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        setMobileMenuOpen(false);
                        setIsOpen(true);
                      }}
                      className="w-full bg-gray-100 text-black py-2.5 rounded-full font-semibold text-center text-[14px] hover:bg-gray-200 transition-colors"
                    >
                      Account setting
                    </button>
                    <button
                      onClick={handleSingOut}
                      className="w-full bg-red-50 text-red-600 py-2.5 rounded-full font-semibold text-center text-[14px] hover:bg-red-100 transition-colors"
                    >
                      Sign out
                    </button>
                  </div>
                )}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      <AnimatePresence initial={false}>
        {(profileShow === 1 || profileShow === 2 || profileShow === 3) && <div className="model items-center">
          <motion.div
            key="content"
            initial="close"
            animate="open"
            exit="close"
            variants={{
              open: { opacity: 1, y: 0 },
              close: { opacity: 0, y: 30 },
            }}
            transition={{ duration: 0.3 }}
            className="account_box"
          >
            <Account />
          </motion.div>
        </div>}
      </AnimatePresence>

      {isOpen && <div onClick={() => setIsOpen(false)} className="w-full h-[100vh] top-0 fixed z-10"></div>}

    </div>
  );
};

export default Header;